import script from "./SlideTransition.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideTransition.vue?vue&type=script&lang=ts&setup=true"

import "./SlideTransition.vue?vue&type=style&index=0&id=484c3c3b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484c3c3b"]])

export default __exports__